// src/services/contactService.js
import axios from 'axios';


const CONTACT_API = 'https://api.ubrenggworks.in/api/contact';

export const submitContactForm = async (formData) => {
  try {
    const response = await axios.post(CONTACT_API, formData);
    return response.data;
  } catch (error) {
    console.error('Error submitting contact form:', error);
    throw error;
  }
};
